<template>
  <div style="position: absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;" class="layout-column" ref="infoBox">
    <lx-dashboard :editable="false" :widget-padding="3">

      <template #widgetContainer="{value}">
        <lx-widget-container :widget-get-value="value" @widgetSetValues="value.setValues">
          <template #widget>
            <empty v-if="value.item.type==='empty'"></empty>
            <activity v-if="value.item.type==='activity'"></activity>
            <downloads v-if="value.item.type==='downloads'"></downloads>
            <news v-if="value.item.type==='news'"></news>
            <feedback v-if="value.item.type==='feedback'"></feedback>
          </template>
        </lx-widget-container>
      </template>

    </lx-dashboard>
  </div>
</template>

<script>

import Empty from './widgets/Empty'
import Activity from './widgets/Activity'
import Downloads from './widgets/Downloads'
import News from './widgets/News'
import Feedback from './widgets/Feedback'

export default {
  name: 'Dashboard',
  props: {
    msg: String
  },
  provide () {
    return {
      widgetTypesInject: this.widgetTypes,
      editable: false,
    }
  },
  components: {
    Empty,
    Activity,
    Downloads,
    News,
    Feedback
  },
  data () {
    return {
      widgetTypes: [
        {
          type: 'empty',
          title: '',
          subtitle: ''
        },
        {
          type: 'activity',
          subtitle: this.$t('COMPONENT_DASHBOARD.ACTIVITY_SUB_TITLE'),
          title: this.$t('COMPONENT_DASHBOARD.ACTIVITY_TITLE'),
          icon: "assignment"
        },
        {
          type: 'downloads',
          icon: "cloud_download",
          subtitle: this.$t('COMPONENT_DASHBOARD.DOWNLOADS_SUB_TITLE'),
          title: this.$t('COMPONENT_DASHBOARD.DOWNLOADS_TITLE')
        },
        {
          type: 'news',
          icon: "speaker_notes",
          subtitle: this.$t('COMPONENT_DASHBOARD.NEWS_SUB_TITLE'),
          title: this.$t('COMPONENT_DASHBOARD.NEWS_TITLE')
        },
        {
          type: 'feedback',
          icon: "feedback",
          subtitle: this.$t('COMPONENT_DASHBOARD.FEEDBACK_SUB_TITLE'),
          title: this.$t('COMPONENT_DASHBOARD.FEEDBACK_TITLE')
        }
      ],
    }
  },
  watch: {
    '$route' : {
      handler: function (to) {
        if (to?.path === '/dashboard') {
          // following action will only be triggered when login, not when re-login
          // search 'dashboard' tab and set them as active tab, if other tab is active
          for (let i = 0; i < this.getTabsFromStore.length; i++) {
            if (this.getTabsFromStore[i].to === '/dashboard' && i !== this.getActiveTabsFromStore) {
              // set dashboard as active tab in view
              this.setActiveTab(i)
              break
            }
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.lx-dashboard {
  .title {
    font-size: 1.1rem !important;
  }

  .subheading {
    font-size: 0.8rem !important;
  }
}

.lx-dash-list {
  .v-list-item {
    min-height: auto !important;

    .v-avatar.v-list-item__avatar {
      margin: 0;
    }

    .v-list-item__content {
      padding: 7px 0;
    }
  }
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>
